import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { closeModal as closeModalActionCreator } from 'services/modal/actions';

import Modal from '../Modal';

import { ConfirmationModalFooter } from './ConfirmationModalFooter';
import { ConfirmationModalProps } from './types';

const ConfirmationModal = ({
  children,
  name,
  submitButtonClassName,
  cancelButtonClassName,
  submitButtonLabel = 'Submit',
  cancelButtonLabel = 'Cancel',
  isSubmitButtonDisabled = false,
  isCancelButtonDisabled = false,
  isSubmitting = false,
  onSubmit = () => {},
  onCancel = () => {},
  ...otherProps
}: ConfirmationModalProps) => {
  const dispatch = useDispatch();

  const closeModal = useCallback(() => {
    dispatch(closeModalActionCreator(name));
  }, [name]);

  const handleSubmitButtonClick = () => {
    onSubmit();
  };

  const handleCancelButtonClick = () => {
    closeModal();
    onCancel();
  };

  return (
    <Modal
      name={name}
      modalFooterComponent={ConfirmationModalFooter}
      modalFooterComponentProps={{
        submitButtonClassName,
        cancelButtonClassName,
        submitButtonLabel,
        cancelButtonLabel,
        isSubmitting,
        isSubmitButtonDisabled,
        isCancelButtonDisabled,
        onSubmitClick: handleSubmitButtonClick,
        onCancelClick: handleCancelButtonClick,
      }}
      {...otherProps}
    >
      {children}
    </Modal>
  );
};

export { ConfirmationModal };
